module.exports = __webpack_public_path__ + "static/media/2016-Mustang-Coupe-5L.41a8e370.jpg";